import type { LegalSectionConfig } from "../../../types/legal";

export const cookieSections: LegalSectionConfig[] = [
    {
        num: "1.",
        titleKey: "cookie_s1_title",
        clauses: [
            {
                num: "1.1",
                introKey: "cookie_s1_intro",
                definitions: [
                    { termKey: "cookie_s1_def1_term", descKey: "cookie_s1_def1_desc" },
                    { termKey: "cookie_s1_def2_term", descKey: "cookie_s1_def2_desc" },
                    { termKey: "cookie_s1_def3_term", descKey: "cookie_s1_def3_desc" },
                ],
            },
        ],
    },
    {
        num: "2.",
        titleKey: "cookie_s2_title",
        clauses: [
            { num: "2.1", textKey: "cookie_s2_c1" },
            { num: "2.2", textKey: "cookie_s2_c2" },
        ],
    },
    {
        num: "3.",
        titleKey: "cookie_s3_title",
        clauses: [
            { num: "3.1", textKey: "cookie_s3_c1" },
            { num: "3.2", textKey: "cookie_s3_c2" },
        ],
    },
    {
        num: "4.",
        titleKey: "cookie_s4_title",
        clauses: [
            { num: "4.1", textKey: "cookie_s4_c1" },
            { num: "4.2", textKey: "cookie_s4_c2" },
            { num: "4.3", textKey: "cookie_s4_c3" },
        ],
    },
    {
        num: "5.",
        titleKey: "cookie_s5_title",
        clauses: [
            { num: "5.1", textKey: "cookie_s5_c1" },
            { num: "5.2", textKey: "cookie_s5_c2" },
        ],
    },
    {
        num: "6.",
        titleKey: "cookie_s6_title",
        clauses: [
            { num: "6.1", textKey: "cookie_s6_c1" },
            { num: "6.2", textKey: "cookie_s6_c2" },
        ],
    },
    {
        num: "7.",
        titleKey: "cookie_s7_title",
        clauses: [
            { num: "7.1", textKey: "cookie_s7_c1" },
            { num: "7.2", textKey: "cookie_s7_c2" },
        ],
    },
    {
        num: "8.",
        titleKey: "cookie_s8_title",
        clauses: [{ num: "8.1", textKey: "cookie_s8_c1" }],
    },
    {
        num: "9.",
        titleKey: "cookie_s9_title",
        clauses: [{ num: "9.1", textKey: "cookie_s9_c1" }],
    },
];
